<template>
  <v-list-item>
    <v-list-item-action>
      <v-icon>fa-file-alt</v-icon>
    </v-list-item-action>
    <v-list-item-content class="py-0">
      <v-select
          v-bind:value="fichaAgricola"
          v-on:input="handleElegirFichaAgricola($event)"
          :items="listaFichaAgricola"
          item-text="nombre"
          item-value="idFichaAgricola"
          class="pt-0"
      >
        <template slot="no-data">
          <v-list-item>
            <v-list-item-title>
              Ninguna ficha disponible
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-select>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
  import {mapActions, mapState} from 'vuex'

  export default {
    name: 'FhMenuFichaAgricola',
    computed: {
      ...mapState('fichas', [
        'fichaAgricola',
        'listaFichaAgricola',
      ]),
      ...mapState('session', [
        'isRestored',
      ]),
      ...mapState('establecimientos', [
        'establecimiento',
        'establecimientosList',
      ]),
    },
    methods: {
      ...mapActions('fichas', [
        'fetchListaFichaAgricola',
        'setFichaAgricola',
      ]),
      async handleElegirFichaAgricola(id) {
        if (this.fichaAgricola.idFichaAgricola === id) return

        await this.setFichaAgricola(id)
      },
    },
    async created() {
      // To prevent a race condition when session isn't restored yet
      while (!this.isRestored && !this.establecimiento.idEstablecimiento) {
        await this.$sleep(10)
      }

      await this.fetchListaFichaAgricola()
    },
  }
</script>

<style scoped>

</style>
